<template>
  <div class="page-wrapper has-tabbar">
    <div class="grabbing-container">
      <div class="header-section">
        <div class="banner-card">
          <img src="@/assets/static/grabbing/2.jpg" mode="aspectFill">
        </div>
      </div>

      <div class="carousel-section">
        <div class="carousel-container">
          <div class="carousel-wrapper">
            <div class="carousel-glow"></div>
            <div class="book-container">
              <div class="page-base">
                <div class="page-overlay">
                  <div class="emoji emoji-1">💎</div>
                  <div class="emoji emoji-2">⭐</div>
                  <div class="emoji emoji-3">🎁</div>
                </div>
              </div>
              <div class="page-curl curling">
                <div class="page-overlay">
                  <div class="emoji emoji-1">💎</div>
                  <div class="emoji emoji-2">⭐</div>
                  <div class="emoji emoji-3">🎁</div>
                </div>
              </div>
            </div>
            <div class="sparkle sparkle-1"></div>
            <div class="sparkle sparkle-2"></div>
            <div class="sparkle sparkle-3"></div>
            <div class="sparkle sparkle-4"></div>
          </div>
          <div class="action-button" @click="grabOrder">
            <div class="button-content">
              <span class="button-icon">⚡</span>
              <span class="button-text">{{ t('grabbing.grabOrder') }}</span>
              <!-- <div class="button-glow"></div> -->
            </div>
            <div class="ripple-container"></div>
          </div>
        </div>
      </div>

      <div class="balance-section">
        <div class="balance-card">
          <div class="balance-title">{{ t('grabbing.accountAmount') }}</div>
          <div class="balance-grid">
            <div class="balance-item">
              <div class="balance-label">{{ t('grabbing.accountBalance') }}</div>
              <div class="balance-value">{{ grabbingData.balance }}</div>
            </div>
            <div class="balance-item">
              <div class="balance-label">{{ t('grabbing.getCommission') }}</div>
              <div class="balance-value">{{ grabbingData.totalCommission }}</div>
            </div>
            <div class="balance-item">
              <div class="balance-label">{{ t('grabbing.ordersGrabbedToday') }}</div>
              <div class="balance-value">{{ grabbingData.dayOrderCount }}</div>
            </div>
            <div class="balance-item">
              <div class="balance-label">{{ t('grabbing.orderCount') }}</div>
              <div class="balance-value">{{ grabbingData.orderNum }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="instructions-section">
        <div class="instructions-card">
          <div class="instructions-title">{{ t('grabbing.operationSteps') }}</div>
          <div class="instruction-item">
            <span class="bullet">•</span>
            <span class="instruction-text">{{ t('grabbing.step1') }}</span>
          </div>
          <div class="instruction-item">
            <span class="bullet">•</span>
            <span class="instruction-text">{{ t('grabbing.step2') }}</span>
          </div>
        </div>
      </div>

      <div class="products-section">
        <div class="products-grid">
          <div class="product-card" v-for="(product, index) in products" :key="index">
            <div class="product-image">
              <img :src="product.image" mode="aspectFill" class="product-img">
              <div class="product-overlay">
                <span class="overlay-text">🛒</span>
              </div>
            </div>
            <div class="product-info">
              <div class="product-name">{{ product.name }}</div>
              <div class="product-price">
                <span class="currency">{{ appConfig.currency.symbol }}</span>
                <span class="price-value">{{ product.price }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="gif-popup-overlay" v-if="showLoadingPopup">
          <div class="gift-container">
            <img src="@/assets/static/1-min.gif" mode="widthFix" class="gift-ani" style="width: 100%;">
          </div>
          <div class="loading text-center">
              <div>{{ t('grabbing.pleaseWait') }}</div>
          </div>
      </div>


      <div class="buy-popup-overlay" v-if="showBuyPopup">
        <div class="buy-popup-container">
            <div class="text-center h2">{{ t('grabbing.grabSuccess') }}</div>
            <div class="box-common">
                <div class="m-flex m-row-between m-margin-top-1"><img :src="currentProduct?.image" mode="widthFix" class="purchase_cont">
                    <div class="column-between" style="width: 75%;">
                        <div class="line-hidden">{{ currentProduct?.name }}</div>
                        <div class="m-flex-flex m-flex-col m-row-right color-ui c-margin-top40"> X{{ currentProduct?.goodsCount || 1 }}</div>
                    </div>
                </div>
                <div class="size-24 color-unimport c-margin-top20">
                    <div class="">{{ t('grabbing.grabTime') }}: {{ currentProduct?.addtime }}</div>
                    <div class="c-margin-top20">{{ t('grabbing.grabNumber') }}: {{ currentProduct?.id }}</div>
                </div>
                <div class="row-between size-24 color-unimport c-margin-top20">
                    <div class="">{{ t('grabbing.orderTotal') }}</div>
                    <div class="">{{ currentProduct?.price }}</div>
                </div>
                <div class="row-between size-24 color-unimport c-margin-top20">
                    <div class="">{{ t('grabbing.commission') }}</div>
                    <div class="">{{ currentProduct?.commission }}</div>
                </div>
                <div class="row-between size-24 c-margin-top20">
                    <div class="color-unimport">{{ t('grabbing.expectedReturn') }}</div>
                    <div class="p3">{{ calculateExpectedReturn(currentProduct?.price, currentProduct?.commission) }}</div>
                </div>
                <div class="size-24 c-margin-top20">
                    <div class="color-unimport">{{ t('grabbing.rating') }}</div>
                    <el-rate
                      v-model="currentRating"
                      :max="5"
                      :colors="['#FF9900', '#FF9900', '#FF9900']"
                      :void-color="'#E4E7ED'"
                      @change="handleRatingChange"
                    />
                </div>
            </div>
            <div class="row-between c-margin-top40">
                <div class="tijioa" @click="closeBuyPopup">{{ t('grabbing.notSubmit') }}</div>
                <div class="tijioa btn-sub m-margin-left-2" @click="submitOrder" :class="{ 'btn-disabled': submitLoading }" style="pointer-events: auto;">
                  <span>{{ submitLoading ? t('grabbing.submitting') : t('grabbing.submitNow') }}</span>
                </div>
            </div>
        </div>
    </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { appConfig } from '@/config/app'
import { doOrder, submitOrder as submitOrderApi, orderInfo, getGrabbingData } from '@/api'
import { ElMessage } from 'element-plus'
import '@/assets/css/grabbing.css'
import bvlgariNecklace from '@/assets/static/goods/bvlgari-necklace.jpg'
import gucciBag from '@/assets/static/goods/gucci-bag.jpg'
import chanelBag from '@/assets/static/goods/chanel-bag.jpg'
import diorTote from '@/assets/static/goods/dior-tote.jpg'
import yslHeels from '@/assets/static/goods/ysl-heels.png'
import cartierWatch from '@/assets/static/goods/cartier-watch.png'

const { t } = useI18n()
const router = useRouter()

const showLoadingPopup = ref(false)
const showBuyPopup = ref(false)
const currentProduct = ref(null)
const currentRating = ref(5)
const submitLoading = ref(false)

const grabbingData = ref({
  balance: '0.00',
  totalCommission: '0.00',
  dayOrderCount: 0,
  orderNum: 0
})

const fetchGrabbingData = async () => {
  try {
    const response = await getGrabbingData()
    console.log('Grabbing数据响应:', response)
    
    if (response.data.code === 200) {
      grabbingData.value = {
        balance: response.data.data.balance,
        totalCommission: response.data.data.total_commission,
        dayOrderCount: response.data.data.day_order_count,
        orderNum: response.data.data.order_num
      }
      console.log('更新后的数据:', grabbingData.value)
    } else {
      console.log('响应码不是200:', response.data.code)
    }
  } catch (error) {
    console.error('获取页面数据失败:', error)
  }
}

onMounted(() => {
  fetchGrabbingData()
})

const products = ref([
  {
    image: bvlgariNecklace,
    name: 'BVLGARI/Bulgari B.ZERO1 series Design Legend 18K gold rose gold spiral paved diamond necklace 355060',
    price: '127506.00'
  },
  {
    image: gucciBag,
    name: 'GUCCI Interlocking Double G Men\'s Mini Handbag Messenger Bag Crossbody Bag [Camera Bag]',
    price: '22742.00'
  },
  {
    image: chanelBag,
    name: 'CHANEL/Chanel Classic WOC Women\'s Black Pebbled Calfskin Flip Shoulder Crossbody Bag Chain Bag',
    price: '62763.00'
  },
  {
    image: diorTote,
    name: 'DIOR/Dior 24 new Dior Book Tote women\'s dark blue logo jacquard cowhide small crossbody/handbag M1325CZBB_M928',
    price: '65136.00'
  },
  {
    image: yslHeels,
    name: 'Ysl/Yves Saint Laurent 24SS01 women\'s logo slingback high heels 630107',
    price: '19232.00'
  },
  {
    image: cartierWatch,
    name: 'Cartier Official Flagship Store Ballon Bleu Blue Balloon Quartz Mechanical Watch Stainless Steel Watch',
    price: '96163.00'
  }
])

const grabOrder = async () => {
  if (submitLoading.value) return
  
  submitLoading.value = true
  
  try {
    const randomIndex = Math.floor(Math.random() * products.value.length)
    currentProduct.value = products.value[randomIndex]
    
    showLoadingPopup.value = true
    
    setTimeout(async () => {
      showLoadingPopup.value = false
      
      try {
        const response = await submitOrderApi({
          real: 0
        })
        
        if (response.data.code === 200) {
          const orderId = Array.isArray(response.data.data.order_id) ? response.data.data.order_id[0] : response.data.data.order_id
          
          try {
            const orderResponse = await orderInfo({
              id: orderId
            })
            
            if (orderResponse.data.code === 200) {
              const apiData = orderResponse.data.data
              currentProduct.value = {
                ...currentProduct.value,
                id: apiData.oid,
                name: apiData.goods_name,
                price: apiData.num,
                image: apiData.goods_pic,
                commission: apiData.commission,
                addtime: apiData.addtime,
                num: apiData.num,
                goodsCount: apiData.goods_count,
                balance: apiData.balance,
                shopName: apiData.shop_name
              }
              showBuyPopup.value = true
            }else {
              ElMessage.error(orderResponse.data.msg)
            }
          } catch (error) {
            console.error('获取订单详情失败:', error)
            ElMessage.error(t('grabbing.getOrderInfoFailed'))
            showBuyPopup.value = true
          }
        } else if (response.data.code === 501) {
              ElMessage.warning(response.data.msg)
              setTimeout(() => {
                router.push('/purchase')
              }, 2000)
        }else {
          ElMessage.error(response.data.msg)
        }
      } catch (error) {
        console.error('抢单失败:', error)
        ElMessage.error(t('grabbing.grabOrderFailed'))
      } finally {
        submitLoading.value = false
      }
    }, 3000)
  } catch (error) {
    console.error('抢单错误:', error)
    submitLoading.value = false
  }
}

const closeBuyPopup = () => {
  showBuyPopup.value = false
}

const submitOrder = async () => {
  if (!currentProduct.value || submitLoading.value) return
  
  submitLoading.value = true
  
  try {
    const response = await doOrder({
      oid: currentProduct.value.id,
      rating: currentRating.value
    })
    
    if (response.data.code === 200) {
      ElMessage.success(response.data.msg)
      showBuyPopup.value = false
      await fetchGrabbingData()
    } else {
      ElMessage.error(response.data.msg)
    }
  } catch (error) {
    console.error('提交订单失败:', error)
    ElMessage.error(t('grabbing.submitOrderFailed'))
  } finally {
    submitLoading.value = false
  }
}

const handleRatingChange = (rating) => {
  console.log('用户评分:', rating)
  // 这里可以添加评分处理的逻辑
}



const calculateExpectedReturn = (price, commission) => {
  if (!price || !commission) return '$0.00'
  const numPrice = parseFloat(price)
  const numCommission = parseFloat(commission)
  const total = (numPrice + numCommission).toFixed(2)
  return `$${total}`
}
</script>

<style scoped>
.header-section {
  margin: 16px
}

.btn-disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none !important;
}
</style>
